import { Center, Loader } from "@mantine/core";

export const FullscreenFallback = () => (
	<Center h="100vh">
		<Loader size="xl" />
	</Center>
);
